<template>
  <div class="container-fluid principal">
    <div class="row">
      <div class="col-md-12">
        <Toast position="top-right" :baseZIndex="2222" />
        <Toolbar class="p-mb-4">
          <template #left>
            <div class="row">
              <div class="col-md-12">
                <Button
                  label="Add"
                  icon="pi pi-plus"
                  class="p-button-success p-mr-2"
                  @click="openNew"
                />
              </div>
            </div>
          </template>
          <template #right>
            <div class="row">
              <div class="col-md-12">
                <Button
                  v-if="excel_loaded"
                  label="Excel"
                  icon="pi pi-save"
                  class="p-button-info p-mr-2"
                  @click="generateExcel"
                />
                <ProgressSpinner
                  v-else
                  style="width: 50px; height: 50px"
                  strokeWidth="8"
                  fill="#EEEEEE"
                  animationDuration=".5s"
                />
              </div>
            </div>
          </template>
        </Toolbar>
        <DataTable
          :value="companies"
          :loading="company_data_table_loading"
          class="p-datatable-striped p-datatable-sm"
          dataKey="company_id"
          :scrollable="true"
          :paginator="true"
          :rows="25"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[25, 50, 75, 150, 300]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} companies"
          editMode="row"
          :editingRows.sync="editingCompanyRows"
          @row-edit-init="onRowEditCompanyInit"
          @row-edit-cancel="onRowEditCompanyCancel"
          @row-edit-save="onRowEditCompanySave"
        >
          <template #header>
            <div class="table-header-container">
              <h5 class="p-m-0">Company</h5>
              <div class="row">
                <div class="col-md-2">
                  <span class="p-input-icon-left input-full-width">
                    <i class="pi pi-search" />
                    <InputText
                      v-model="filters['global']"
                      placeholder="Search..."
                      class="input-search-width"
                    />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-for="col of selected_columns">
            <Column
              v-if="col.field == 'company_id'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.company_id == ''"
                  class="p-sortable-column"
                  @click="
                    sortCompanyDataTable(
                      'company_id',
                      'company_id',
                      sorted_by.company_id
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.company_id == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_id',
                      'company_id',
                      sorted_by.company_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.company_id == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_id',
                      'company_id',
                      sorted_by.company_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'company_name'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.company_name == ''"
                  class="p-sortable-column"
                  @click="
                    sortCompanyDataTable(
                      'company_name',
                      'company_name',
                      sorted_by.company_name
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.company_name == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_name',
                      'company_name',
                      sorted_by.company_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.company_name == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_name',
                      'company_name',
                      sorted_by.company_name
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>

            <Column
              v-else-if="col.field == 'company_code'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.company_code == ''"
                  class="p-sortable-column"
                  @click="
                    sortCompanyDataTable(
                      'company_code',
                      'company_code',
                      sorted_by.company_code
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.company_code == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_code',
                      'company_code',
                      sorted_by.company_code
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.company_code == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_code',
                      'company_code',
                      sorted_by.company_code
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>

              <template #editor="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'company_master_id'"
              :field="col.field"
              :key="col.field"
              headerStyle="text-align: center;width: 175px"
              bodyStyle="text-align: center;width: 175px;"
            >
              <template #header>
                <span
                  v-if="sorted_by.company_master_id == ''"
                  class="p-sortable-column"
                  @click="
                    sortCompanyDataTable(
                      'company_master_id',
                      'company_master_id',
                      sorted_by.company_master_id
                    )
                  "
                  >{{ col.header }}
                  <span
                    class="p-sortable-column-icon pi pi-fw pi-sort-alt"
                  ></span>
                </span>
                <span
                  v-else-if="sorted_by.company_master_id == 'ASC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_master_id',
                      'company_master_id',
                      sorted_by.company_master_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-highlight p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
                  ></span
                ></span>
                <span
                  v-else-if="sorted_by.company_master_id == 'DESC'"
                  class="p-sortable-column p-sortable-column p-highlight"
                  @click="
                    sortCompanyDataTable(
                      'company_master_id',
                      'company_master_id',
                      sorted_by.company_master_id
                    )
                  "
                  >{{ col.header
                  }}<span
                    class="p-sortable-column-icon pi pi-fw pi-sort-amount-down"
                  ></span
                ></span>
              </template>
              <template #body="slotProps">
                <span
                  v-if="
                    !slotProps.data.company_is_master &&
                    slotProps.data.company_master_id.length > 0
                  "
                >
                  {{ slotProps.data.company_master_details.company_name }}
                </span>
              </template>
              <template #editor="slotProps">
                <Checkbox
                  id="convert_to_master"
                  v-model="slotProps.data.company_is_master"
                  :binary="true"
                />
                <label for="convert_to_master" style="display: initial">
                  Convertir en Holding </label
                ><br />
                <Dropdown
                  v-if="!slotProps.data.company_is_master"
                  v-model="slotProps.data[slotProps.column.field]"
                  class="input-full-width"
                  :options="holding_companies"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choose a company"
                  :filter="true"
                  emptyFilterMessage="No results found"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'actions' && can_show_actions"
              headerStyle="text-align: center;width: 7rem"
              bodyStyle="text-align: center;width: 7rem; text-align: center;"
              :key="col.field"
            >
              <template #body="slotProps">
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger button-margin-right"
                  @click="confirmDeleteCompany(slotProps.data)"
                />
              </template>
            </Column>
            <Column
              v-else-if="col.field == 'editCompany'"
              :rowEditor="true"
              headerStyle="text-align: center;width: 7rem"
              bodyStyle="text-align: center;width: 7rem; text-align:center;"
              :key="col.field"
            >
            </Column>
          </template>
        </DataTable>
        <Dialog
          :baseZIndex="2222"
          :visible.sync="createCompanyDialog"
          :style="{ width: '475px' }"
          header="Nuevo Company"
          :modal="true"
          :maximizable="true"
          position="center"
          class="p-fluid"
        >
          <div class="p-field">
            <label for="company_name">Name</label>
            <br />
            <InputText
              id="company_name"
              v-model="newCompany.company_name"
              class="input-full-width"
              required="true"
              placeholder="Ex. Visual Import S.A."
              :class="{
                'p-invalid': newCompanySubmitted && invalid.company_name,
              }"
            />
            <small
              class="p-invalid"
              v-if="newCompanySubmitted && invalid.company_name"
              >Please complete this field.</small
            ><br /><br />
          </div>
          <div class="p-field">
            <Checkbox
              id="associate_to_holding"
              v-model="associate_to_holding"
              :binary="true"
            />
            <label for="associate_to_holding" style="display: initial">
              Add to Holding </label
            ><br /><br v-if="associate_to_holding" />
            <Dropdown
              v-if="associate_to_holding"
              v-model="newCompany.company_master_id"
              class="input-full-width"
              :class="{
                'p-invalid': newCompanySubmitted && invalid.company_master_id,
              }"
              :options="holding_companies"
              optionLabel="label"
              optionValue="value"
              placeholder="Choose a company"
              :filter="true"
              emptyFilterMessage="No results found"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.label }}</span>
              </template>
            </Dropdown>
            <small
              class="p-invalid"
              v-if="newCompanySubmitted && invalid.company_master_id"
              >Please complete this field. </small
            ><br />
          </div>
          <div class="p-field">
            <label for="company_code">Code</label>
            <br />
            <InputText
              id="company_code"
              v-model="newCompany.company_code"
              class="input-full-width"
              required="true"
              placeholder="Ex. VSI"
              :class="{
                'p-invalid': newCompanySubmitted && invalid.company_code,
              }"
            />
            <small
              class="p-invalid"
              v-if="newCompanySubmitted && invalid.company_code"
              >Please complete this field.</small
            ><br /><br />
          </div>
          <template #footer>
            <Button
              v-if="!load_creation"
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              v-if="!load_creation"
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveNewCompany"
            />
            <ProgressSpinner
              v-else
              style="text-align: center;width: 50px; height: 50px"
              strokeWidth="8"
              fill="#EEEEEE"
              animationDuration=".5s"
            /> </template
        ></Dialog>

        <Dialog
          :baseZIndex="2222"
          :visible.sync="deleteCompanyDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="company">
              Are you sure you want to delete this data?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteCompanyDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedCompany"
            /> </template
        ></Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Toast from "primevue/toast";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Textarea from "primevue/textarea";
import Avatar from "primevue/avatar";
import Tag from "primevue/tag";
import Vue from "vue";
import Dropdown from "primevue/dropdown";
import ProgressSpinner from "primevue/progressspinner";
import Calendar from "primevue/calendar";
import InputSwitch from "primevue/inputswitch";
import Checkbox from "primevue/checkbox";
export default {
  name: "login-page",
  bodyClass: "login-page",

  data() {
    return {
      excel_loaded: true,
      holding_companies: [],
      associate_to_holding: false,
      companies: [],
      createCompanyDialog: false,
      deleteCompanyDialog: false,
      company: {},
      newCompany: {
        company_name: "",
        company_code: "",
        company_is_master: "",
        company_master_id: "",
      },
      filters: {},
      newCompanySubmitted: false,
      columns: [],
      selected_columns: [],
      sorted_by: {
        company_id: "",
        company_name: "",
        company_code: "",
        company_master_id: "",
        company_is_master: "",
      },
      company_data_table_loading: true,
      editingCompanyRows: [],
      editingImportRows: [],
      editingAfterSalesRows: [],
      selected_company_id: "",
      can_show_actions: false,
      invalid: {
        company_name: false,
        company_master_id: false,
        company_code: false,
      },
      load_creation: false,
    };
  },
  created() {
    this.columns = [
      { field: "company_id", header: "COMPANY ID" },
      { field: "company_name", header: "NAME" },
      { field: "company_code", header: "CODE" },
      { field: "company_master_id", header: "HOLDING" },
      { field: "actions", header: "Acciones" },
      { field: "editCompany", header: "Edit" },
    ];
    this.selected_columns = this.columns;
    this.originalRows = {};
  },
  mounted() {
    this.getCompanies();
  },
  methods: {
    generateExcel() {
      let token = this.getToken();
      this.excel_loaded = false;
      this.axios
        .post(
          `${process.env.VUE_APP_COMPANIES}/excel`,
          { companies: this.companies },
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          this.$toast.add({
            severity: "success",
            summary: "Exported Data",
            detail: "The data has been successfully exported.",
            life: 5000,
          });
          Object.assign(document.createElement("a"), {
            target: "_blank",
            href: res.data.path,
          }).click();
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while generating the excel, try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.excel_loaded = true;
        });
    },
    getMasterCompanies() {
      this.holding_companies = [];
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_COMPANIES}?depth=true&company_is_master=true`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          let result_companies = res.data;
          result_companies.forEach((element) => {
            this.holding_companies.push({
              label: element.company_name,
              value: element.company_id,
            });
          });
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {});
    },
    getCompanies() {
      this.company_data_table_loading = true;
      let token = this.getToken();
      this.axios
        .get(`${process.env.VUE_APP_COMPANIES}?depth=true`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.companies = res.data;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.can_show_actions = true;
          this.company_data_table_loading = false;
        });
    },
    setsortCompanyDataTable(sort_data, sort_value) {
      Object.keys(this.sorted_by).forEach((key) => {
        if (key == sort_data) {
          this.sorted_by[key] = sort_value;
          let is_asc = sort_value == "DESC" ? true : false;
          if (this.sorted_by[key] != "") {
            this.sortCompanies(key, is_asc);
          } else {
            this.getCompanies();
          }
        } else {
          this.sorted_by[key] = "";
        }
      });
    },
    sortCompanies(sort_by, is_asc) {
      this.company_data_table_loading = true;
      let token = this.getToken();
      this.axios
        .get(
          `${process.env.VUE_APP_COMPANIES}?sort=${sort_by}&asc=${is_asc}&depth=true`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // console.log(res.data);
          this.companies = res.data;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.company_data_table_loading = false;
        });
    },
    sortCompanyDataTable(sort_by, sort_data, sort_value) {
      // console.log(sort_by, sort_data, sort_value);
      if (sort_value == "") {
        sort_value = "ASC";
        this.setsortCompanyDataTable(sort_data, sort_value);
      } else if (sort_value == "ASC") {
        sort_value = "DESC";
        this.setsortCompanyDataTable(sort_data, sort_value);
      } else if (sort_value == "DESC") {
        sort_value = "";
        this.setsortCompanyDataTable(sort_data, sort_value);
      }
    },
    getToken() {
      let token = localStorage.getItem("idToken");
      return token;
    },
    openNew() {
      this.getMasterCompanies();
      this.newCompany = {
        company_name: "",
        company_code: "",
        company_is_master: !this.associate_to_holding,
        company_master_id: "",
      };
      this.newCompanySubmitted = false;
      this.createCompanyDialog = true;
    },
    hideDialog() {
      this.createCompanyDialog = false;
      this.newCompanySubmitted = false;
      this.newCompany = {
        company_name: "",
        company_code: "",
        company_is_master: !this.associate_to_holding,
        company_master_id: "",
      };
    },
    saveNewCompany() {
      this.newCompanySubmitted = true;
      this.invalid.company_name =
        this.newCompany.company_name.trim().length == 0 ? true : false;
      this.invalid.company_code =
        this.newCompany.company_code.trim().length == 0 ? true : false;
      if (this.associate_to_holding) {
        this.invalid.company_master_id =
          this.newCompany.company_master_id.trim().length == 0 ? true : false;
      }
      this.newCompany.company_is_master = !this.associate_to_holding;
      if (
        !this.invalid.company_name &&
        !this.invalid.company_code &&
        !this.invalid.company_master_id
      ) {
        this.createCompany();
      }
    },
    createCompany() {
      this.load_creation = true;
      let token = this.getToken();
      this.axios
        .post(`${process.env.VUE_APP_COMPANIES}`, this.newCompany, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Company Created",
            detail: "The company has been created successfully.",
            life: 5000,
          });
        })
        .catch((error) => {
          // console.log(error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while creating the company, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.createCompanyDialog = false;
          this.newCompany = {
            company_name: "",
            company_code: "",
            company_master_id: "",
            company_is_master: !this.associate_to_holding,
          };
          this.load_creation = false;
          this.getCompanies();
        });
    },
    confirmDeleteCompany(company) {
      this.company = company;
      this.deleteCompanyDialog = true;
    },
    deleteSelectedCompany() {
      let token = this.getToken();
      this.deleteCompanyDialog = false;
      this.company_data_table_loading = true;
      this.axios
        .delete(`${process.env.VUE_APP_COMPANIES}/${this.company.company_id}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Deleted data",
            detail: "The selected data was successfully deleted.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while removing the company, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getCompanies();
        });
    },
    onRowEditCompanyInit(event) {
      this.originalRows[event.index] = { ...this.companies[event.index] };
      this.selected_company_id = event.data.company_id;
      // this.companies = [];
      this.canEditAnother = false;
      this.getMasterCompanies();
      // this.getCompaniesByCompanyAndCompany();
      // console.log(event);
      setTimeout(() => {
        this.displayEditButton(false);
      }, 50);
    },
    onRowEditCompanyCancel(event) {
      // console.log(this.companies, event.index, this.originalRows[event.index]);
      // this.edit_user_profile = false;
      // Vue.set(this.companies, event.index, this.originalRows[event.index]);
      this.getCompanies();
      this.displayEditButton(true);
    },
    onRowEditCompanySave(event) {
      // console.log(event);
      let company_id = event.data.company_id;
      let company_data = event.data;
      delete company_data["company_master_details"];
      this.updateCompany(company_id, company_data);
      this.displayEditButton(true);
    },
    displayEditButton(can_display) {
      if (can_display) {
        let edit_buttons = document.querySelectorAll(
          "button.p-row-editor-init.p-link"
        );
        for (let index = 0; index < edit_buttons.length; index++) {
          let element = edit_buttons[index];
          element.style.display = "";
        }
      } else {
        let edit_buttons = document.querySelectorAll(
          "button.p-row-editor-init.p-link"
        );
        for (let index = 0; index < edit_buttons.length; index++) {
          let element = edit_buttons[index];
          element.style.display = "none";
        }
      }
    },
    updateCompany(company_id, body) {
      let token = this.getToken();
      this.company_data_table_loading = true;
      this.axios
        .put(`${process.env.VUE_APP_COMPANIES}/${company_id}`, body, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          // console.log(res.data);
          this.$toast.add({
            severity: "success",
            summary: "Company Updated",
            detail: "The company has been updated successfully.",
            life: 5000,
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail:
              "An error occurred while updating the company, please try again later.",
            life: 5000,
          });
        })
        .finally(() => {
          this.getCompanies();
        });
    },
  },
  components: {
    DataTable,
    Column,
    Toast,
    InputText,
    Toolbar,
    RadioButton,
    InputNumber,
    Button,
    Dialog,
    Textarea,
    Avatar,
    Tag,
    Dropdown,
    ProgressSpinner,
    Calendar,
    InputSwitch,
    Checkbox,
  },
};
</script>
<style scoped>
.input-full-width {
  width: -webkit-fill-available !important;
}
.button-margin-right {
  margin-right: 2px;
}
.input-search-width {
  width: 150px !important;
}
</style>